import { BaseStore } from 'fluxible/addons';
import humps from 'humps';

class BriefStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.briefData = {};
    }

    load(payload) {
        this.briefData = humps.camelizeKeys(payload.body);

        if (payload.language_options) {
            this.languageOptions = payload.language_options;
        }

        if (payload.industry_options) {
            this.industryOptions = payload.industry_options;
        }

        if (payload.has_stock_question) {
            this.hasStockQuestion = payload.has_stock_question;
        }

        this.emitChange();
    }

    update(payload) {
        Object.keys(payload).map(key => {
            this.briefData[key] = payload[key];
        });

        this.emitChange();
    }
}

BriefStore.storeName = 'BriefStore';
BriefStore.handlers = {
    LOAD_DRAFT_DATA: 'load',
    SAVE_DRAFT_SUCCESS: 'load',
    UPDATE_BRIEF: 'update',
};

export default BriefStore;



// WEBPACK FOOTER //
// ./js/launch/stores/BriefStore.js